import PartialRepayment from './PartialRepayment';
export { PartialRepayment };



// WEBPACK FOOTER //
// ./src/containers/PartialRepayment/index.js